<template>
  <div id="result" class="div_card">
    <div v-if="docRecord==null">      
      <el-alert
        title="資料讀取中…"
        type="info"
        show-icon
        center
        :closable="false">
      </el-alert>
    </div>
    <div v-else-if="docRecord!=null && docRecord.status==1">
      <div class="">
        <div class="">
          <table class="w-100" style="background-color: azure; border: gray;" rules="all" bgcolor="#FFFFFF" >
            <thead>
              <tr>
                <th colspan="3" class="ncut-base-form-title" style="background-color: orange; text-align:left; padding: 0.5em;">報到狀態查詢：</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td class="ncut-base-form-title" style="width: 14%;padding:0.5em;">考生姓名</td>
                <td colspan="2" style="padding:0.1em;">
                  <span class="badge badge-info" style="font-size:1.25rem">{{docRecord.name}}</span>
                </td>                
              </tr>
              <tr>                
                <td class="ncut-base-form-title" style="width: 14%;padding:0.5em;">申請編號</td>
                <td colspan="2" style="padding:0.1em;">
                  <span class="badge badge-info" style="font-size:1.25rem">{{docRecord.regNo}}</span>                  
                </td>
              </tr>
              <!-- <tr>
                <td class="ncut-base-form-title" style="padding:0.5em;">錄取狀況</td>
                <td colspan="5" style="padding:0.1em;">
                  <span class="badge" style="font-size: 1.5rem"
                        v-bind:style="{'background': statusColor}">{{docRecord.note}}</span>
                </td>
              </tr> -->
              <tr>
                <td class="ncut-base-form-title" style="padding:0.5em;">錄取系科</td>
                <td colspan="2" style="padding:0.1em;">
                  <span class="badge badge-primary" style="font-size:1.5rem">{{docRecord.deptName}}</span>
                </td>
              </tr>    
              <tr>
                <td class="ncut-base-form-title" style="padding:0.5em;">報到狀態</td>
                <td colspan="2" style="padding:0.1em;">
                  <span class="badge badge-primary" style="font-size:1.5rem">{{docRecord.entName}}</span>
                </td>
              </tr>              
              <!-- <tr v-if="1<docRecord.showStatus">
                <td class="ncut-base-form-title" style="font-weight:bold; padding: 0.5em;">錄取通知單</td>
                <td colspan="3" style="padding:0.1em;">                  
                  <a :href="'./WebApi/Apply/GetRegisterPrnV2/'+user.dId" download="錄取通知單.pdf">列印</a>
                </td>
              </tr>
              <tr>
                <td class="ncut-base-form-title" style="padding:0.5em;">最低錄取分數</td>
                <td colspan="3" style="padding:0.5em;">
                  <div style="padding: 0.25em 0;">
                    <span>正取生：<span v-if="0<docRecord.floor1">{{docRecord.floor1| numFilter}}</span><span v-if="0==docRecord.floor1">-</span></span>分
                  </div>
                  <div style="padding: 0.25em 0;">
                    <span>備取生：<span v-if="0<docRecord.floor2">{{docRecord.floor2| numFilter}}</span><span v-if="0==docRecord.floor2">-</span></span>分
                  </div>
                </td>
              </tr> -->              
              <tr>
                <td class="ncut-base-form-title">備註</td>
                <td colspan="2" style="padding: 0.5em;">
                  <div style="padding: 0.5em 0 0;" 
                    v-html="docRecord.note"/>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
    <div v-else-if="docRecord!=null && docRecord.status==5">
      <el-alert
        title="尚未開放!"
        type="error"
        show-icon
        center
        :closable="false">
      </el-alert>
    </div>
    <div v-else>
      <el-alert
        title="尚無資料，請耐心等候，謝謝!!"
        type="warning"
        show-icon
        center
        :closable="false">
      </el-alert>
    </div> 
  </div> 
</template>


<script>
export default {
  name: 'checkInStatusView',
  data () {
    return {
      docRecord:null
      
    }
  },
  computed: {
    sysId () {
      return this.$store.getters.getSysId
    },
    setting () {
      return this.$store.getters.getSetting
    },
    enroll () {
      return this.$store.getters.getEnrollInfo
    },
    user () {
      return this.$store.getters.getUser
    },    
  },
  filters: {
    numFilter(value) {
      let realVal = parseFloat(value).toFixed(2)
      return parseFloat(realVal)
    }
  },
  methods: {   
    isNull(data) {
      return ((data != null) && (data != undefined) && (data != "null") ? false : true);
    },
    showErrorMsg(vm, msg) {
      vm.$notify.error({
                        title: vm.$t('message.Error_txt'),
                        dangerouslyUseHTMLString: true,
                        message: msg,
                        offset: 150
                      });
    }, 
    loadInfoList() {
      var vm = this
      this.$http
          .get('./WebApi/Apply/GetCheckInResult/'.concat(this.user.dId))
          .then(function(response) {
            if (response.data != null) {            
              vm.docRecord = response.data;
            } else {
              vm.showErrorMsg(vm, '<strong>對不起,讀取<i style="background:yellow;">結果</i>查詢失敗:'+error+'</strong>');
            }
          })
          .catch(function (error) {
            vm.showErrorMsg(vm, '<strong>對不起,網路連線失敗' + error+'</strong>');
          })
    }
    
    
  },
  
  created () { 
    console.log('======created FirstResultView=====');
    this.loadInfoList();    
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/CheckInStatusView.vue